<template>
  <UPageCard
    icon="i-lucide-heart"
    title="Nuxt needs you!"
    description="By allowing nuxt.com on your Ad-Blocker, you support our work and help us financially."
    to="https://nuxt.com/support"
    target="_blank"
    :ui="{
      leadingIcon: 'text-pink-500 dark:text-pink-400',
      container: 'p-3 sm:p-3 gap-y-2',
      header: 'mb-0',
      title: 'text-sm',
      description: 'text-sm'
    }"
  />
</template>
